module.exports = __webpack_public_path__ + "media/images/common/icon-search-3d3ee2fd97d827381a50e860174fb1d2.png";